<section class="blockInfo bg_red">
    <div class="container">
        <div class="blockInfo__wrap">
            <div class="blockInfo__txt w-auto">
                <h2 class="ttl2" i18n>{{info.title1}} <br> {{info.title2}}</h2>
            </div>
            <button (click)="navigateToSection(info.section)" class="btn btnWhite" mat-button i18n>{{info.button}}</button>
        </div>
    </div>
</section>